import { func, string } from 'prop-types';

const OfficeViewer = (props) => {
  const { 
    contentUrl, 
    fileName,
    setError,
  } = props;
  
  return <iframe
    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(contentUrl)}`}
    width="100%"
    height="100%"
    frameBorder="0"
    title={`Vista previa de ${fileName}`}
    style={{ 
      border: 'none',
      minHeight: '75dvh',
    }}
    onError={() => setError('Error al cargar el documento')}
  />;
};

OfficeViewer.propTypes = {
  contentUrl: string,
  fileName: string,
  setError: func,
};
export default OfficeViewer;
